export enum AssessmentQuestionType {
    TextInput = 0,
    FileUpload = 1,
    MultipleChoice = 2,
    SingleChoice = 3,
  }
  
  export interface Choice {
    choice_id: number;
    text: string;
    isCorrect?: boolean;
  }

  export interface BaseQuestion {
    id: number | null;
    type: AssessmentQuestionType;
    description: string;
    points: number;
    file?: File | null;
}
  
  export interface MultipleChoiceQuestion extends BaseQuestion {
    type: AssessmentQuestionType.MultipleChoice;
    choices: Choice[];
    answer: number[];
  }
  
  export interface TextInputQuestion extends BaseQuestion {
    type: AssessmentQuestionType.TextInput;
    answer: string;
  }
  
  export interface FileUploadQuestion extends BaseQuestion {
    type: AssessmentQuestionType.FileUpload;
    answer: string;
  }

  export interface SingleChoiceQuestion extends BaseQuestion {
    type: AssessmentQuestionType.SingleChoice;
    choices: Choice[];
    answer: number[];
  }

  export type AssessmentQuestion = MultipleChoiceQuestion | TextInputQuestion | FileUploadQuestion | SingleChoiceQuestion;
  